export default {
  props: ['orderId', 'poNumber', 'trackingDetails'],
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    packageItemStatus(packageItem) {
      try {
        if (packageItem.events.length) {
          const item = (packageItem.events || []).sort((a, b) => a.time - b.time)[0];
          if (item && item.name !== packageItem.status) {
            return `${item.name}(${packageItem.status})`;
          }
        }
      } catch (e) {}
      return packageItem.status;
    },
    async checkStatus(packageItem) {
      try {
        this.isLoading = true;
        packageItem = (
          await this.$http.get(
            `/orders/${this.orderId}/purchaseOrders/${this.poNumber}/tracking/${packageItem._id}/events`
          )
        ).data;
        if (this.trackingDetails) {
          this.trackingDetails.trackingPackages.forEach((item) => {
            if (item._id === packageItem._id) {
              item.events = packageItem.events;
              item.shippedDate = packageItem.shippedDate;
              item.deliveredDate = packageItem.deliveredDate;
            }
          });
        }
        if (this.item) {
          if (this.item._id === packageItem._id) {
            this.item.events = packageItem.events;
          }
        }
        this.$forceUpdate();
        // this.$emit('reload');
      } catch (e) {
        this.notifyError(e.data?.message || e.message || e);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
